<template>
  <div class="d-flex align-center" style="gap: 8px">
    <v-menu offset-y rounded="lg">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" text outlined> Email status <v-icon right> mdi-chevron-down</v-icon></v-btn>
      </template>
      <v-list class="px-2">
        <v-checkbox
          @change="changeSelect"
          v-model="checkValueEmail"
          value="sent"
          label="Sent"
          class="mt-0"
          hide-details
        ></v-checkbox>
        <v-checkbox
          @change="changeSelect"
          v-model="checkValueEmail"
          value="not_sent"
          label="Not sent"
          hide-details
        ></v-checkbox>
        <v-checkbox
          class="fz14"
          @change="changeSelect"
          v-model="checkValueEmail"
          value="scheduled"
          label="Scheduled"
          hide-details
        ></v-checkbox>
      </v-list>
    </v-menu>
    <v-menu offset-y rounded="lg">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" text outlined> SMS status <v-icon right> mdi-chevron-down</v-icon></v-btn>
      </template>
      <v-list class="px-2">
        <v-checkbox
          @change="changeSelect"
          v-model="checkValueSMS"
          class="mt-0"
          value="sent"
          label="Sent"
          hide-details
        ></v-checkbox>
        <v-checkbox
          @change="changeSelect"
          v-model="checkValueSMS"
          value="not_sent"
          label="Not sent"
          hide-details
        ></v-checkbox>
        <v-checkbox
          @change="changeSelect"
          v-model="checkValueSMS"
          value="fieled"
          label="Failed"
          hide-details
        ></v-checkbox>
        <v-checkbox
          @change="changeSelect"
          v-model="checkValueSMS"
          value="scheduled"
          label="Scheduled"
          hide-details
        ></v-checkbox>
      </v-list>
    </v-menu>
    <v-menu offset-y rounded="lg">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" text outlined> Recovery status <v-icon right> mdi-chevron-down</v-icon></v-btn>
      </template>
      <v-list class="px-2">
        <v-checkbox
          @change="changeSelect"
          v-model="checkValueRecovery"
          value="recovered"
          label="Recovered"
          class="mt-0"
          hide-details
        ></v-checkbox>
        <v-checkbox
          @change="changeSelect"
          v-model="checkValueRecovery"
          value="not_recovered"
          label="Not recovered"
          hide-details
        ></v-checkbox>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checkValueEmail: [],
      checkValueSMS: [],
      checkValueRecovery: [],
      email: false,
      recovery: false,
      sms: false,
    };
  },
  mounted() {
    console.log(this.$route.query);
    if (this.$route.query.emailStatus) {
      this.checkValueEmail = this.$route.query.emailStatus.split(',');
    }
    if (this.$route.query.smsStatus) {
      this.checkValueSMS = this.$route.query.smsStatus.split(',');
    }
    if (this.$route.query.recoveryStatus) {
      this.checkValueRecovery = this.$route.query.recoveryStatus.split(',');
    }
  },
  methods: {
    // result() {
    //   console.log(this.checkValue);
    // },
    // method của select
    changeSelect() {
      let data = {};
      if (this.checkValueEmail.length > 0) {
        data.emailStatus = this.checkValueEmail.join();
      }
      if (this.checkValueSMS.length > 0) {
        data.smsStatus = this.checkValueSMS.join();
      }
      if (this.checkValueRecovery.length > 0) {
        data.recoveryStatus = this.checkValueRecovery.join();
      }
      this.$emit('getSelect', data);
    },
  },
};
</script>
